import CellValuationRequest from '@/apps/MainApp/views/Dashboard/TableCells/CellValuationRequest.vue'
import reRules from '@/plugins/rules'

export const registerValuationRequestRefColumn = (dashboard, { showDuplicates }) => {
  dashboard.registerCustomColumn({
    name: 'valuation_request_ref',
    label: 'monolith.shared.request_ref',
    component: CellValuationRequest,
    options: {
      searchable: true,
      validation: [reRules.minLength(12)],
      props: {
        onShowDuplicates: showDuplicates,
      },
    },
  })
}
